import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

/** Modern kabuk alt bilgisi. Klasik footer ile aynı içerik, akış içinde konumlanır. */
@Component({
  selector: 'app-modern-footer',
  templateUrl: './modern-footer.component.html',
  styleUrls: ['./modern-footer.component.scss']
})
export class ModernFooterComponent {
  environment = environment;
  year: number = new Date().getFullYear();
}
